import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import CoolerStuffPage from './pages/CoolerStuffPage';
import './styles/index.css';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/cooler-stuff" element={<CoolerStuffPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

